export default "__VITE_ASSET__B7W3_$Af__"